import {ComponentFactoryResolver, Injectable,} from "@angular/core";
import {HttpClient, HttpHeaders, HttpParams, HttpErrorResponse} from "@angular/common/http";
import {ApiService} from "../api/api.service";
import {Observable, throwError} from "rxjs";
import { catchError } from "rxjs/operators";
import {Constant, ContentTypeValues} from 'src/app/common/constant/constant';

@Injectable({
    providedIn: "root",
})
export class LandingpageService {
    private isLoggedIn = true;

    constructor(
        private cfr: ComponentFactoryResolver,
        private http: HttpClient,
        private apiUrl: ApiService
    ) {
    }

    httpOptions = {
        headers: new HttpHeaders({
            'Access-Control-Allow-Methods': 'DELETE, POST, GET, OPTIONS',
            'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
        })
    };

    errorMgmt(error: HttpErrorResponse) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
          // Get client-side error
          errorMessage = error.error.message;
        } else {
          // Get server-side error
          errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        console.log(errorMessage);
        return throwError(errorMessage);
      }

    getUserProfile(userData): Observable<any> {
        const params = new HttpParams()
            .set("api_key", userData.api_key)
            .set("user_id", userData.user_id)
            .set("domain_id", userData.domain_id);
        const body = JSON.stringify(userData);

        return this.http.post<any>(this.apiUrl.apiUserProfile(), body, {
            params: params,
        });
    }

    GetLandingpageOptions(userData) {
        return this.http.post<any>(
            this.apiUrl.apiGetLandingpageOptions(),
            userData
        );
    }

    GetLandingpageOptionsV3(userData) {
        return this.http.post<any>(
            this.apiUrl.apiGetLandingpageOptionsV3(),
            userData
        );
    }

    ManualsAndAnnouncementList(userData) {
        return this.http.post<any>(
            this.apiUrl.apiManualsAndAnnouncementList(),
            userData
        );
    }

      // RO solr api
  getSimilarSolr(type, data={}) {
    const body = JSON.stringify(data);
    return this.http.post<any>(this.apiUrl.apiSimilarSolrList(type), body)
  }
    
    getSimilarSIBSolr(type, data={}) {
    const body = JSON.stringify(data);
    return this.http.post<any>(this.apiUrl.apiSimilarSIBSolrList(type), body)
    }    

    getSolrDataDetail(partsData) {
        console.log(partsData)
        let query = (partsData.query) ? partsData.query : '';
        const params = new HttpParams()
            .set('apiKey', partsData.apiKey)
            .set('userId', partsData.userId)
            .set('domainId', partsData.domainId)
            .set('countryId', partsData.countryId)
            .set('partId', partsData.partId)
            .set('query', query)
        const body = JSON.stringify(partsData);
        if (partsData.listing == 1) {
            return this.http.post<any>(this.apiUrl.apiSolrDataList(), body)
        } else {
            return this.http.post<any>(this.apiUrl.apiSolrSearchList(), body)
        }
    }

    /* getSolrCluster(data) {
       let cparams;
       cparams = new HttpParams()
       .set("uuid", data.uuid)
       return this.http.get<any>(this.apiUrl.apiSolrClusterList(), {
         params: cparams,
       });
     } */

    getSolrCluster(partsData) {
        console.log(partsData)
        let query = (partsData.query) ? partsData.query : '';
        const params = new HttpParams()
            .set('apiKey', partsData.apiKey)
            .set('userId', partsData.userId)
            .set('domainId', partsData.domainId)
            .set('countryId', partsData.countryId)
            .set('partId', partsData.partId)
            .set('query', query)
        const body = JSON.stringify(partsData);
        return this.http.post<any>(this.apiUrl.apiSolrClusterListNew(), body)
    }

    getSolrFixSuggList(type, data) {

        let cparams;
        cparams = new HttpParams()
            .set("type", data.type)
            .set("domainId", data.domainId)
            .set("query", data.query)
            .set("workstreamsIds", data.workstreamsIds)
            .set("approvalProcess", data.approvalProcess)
            .set("uuid", data.uuid)
            .set("platform", data.platform)
            .set("userId", data.userId)
        return this.http.get<any>(this.apiUrl.apiSolrFixSuggList(), {
            params: cparams,
        });


    }

    getSolrSuggDetail(type, data) {
        if (Constant.TVSSSO == '1') {
            switch (type) {
                case 'report':
                    let params = new HttpParams()
                        .set("type", data.type)
                        .set("domainId", data.domainId)
                        .set("query", data.query)
                        .set("uuid", data.uuid)
                        .set("platform", data.platform)
                        .set("userId", data.userId)
                        .set("reportWorsktream", data.reportWorsktream);
                    return this.http.get<any>(this.apiUrl.apiSolrReportSuggList(), {
                        params: params,
                    });
                    break;
                default:
                    let platformId = localStorage.getItem('platformId');
                    let cparams;
                    if (platformId == '1' && data.type != 7 && data.filter != '1') {
                        if (data.shopIdInt) {
                            cparams = new HttpParams()
                                .set("type", data.type)
                                .set("domainId", data.domainId)
                                .set("query", data.query)
                                .set("workstreamsIds", data.workstreamsIds)
                                .set("shopIdInt", data.shopIdInt)
                                .set("approvalProcess", data.approvalProcess)
                                .set("uuid", data.uuid)
                                .set("platform", data.platform)
                                .set("userId", data.userId)
                            return this.http.get<any>(this.apiUrl.apiSolrSuggList(), {
                                params: cparams,
                            });
                        } else if (data.orFilters) {
                            cparams = new HttpParams()
                                .set("type", data.type)
                                .set("domainId", data.domainId)
                                .set("query", data.query)
                                //.set("workstreamsIds", data.workstreamsIds)
                                .set("orFilters", data.orFilters)
                                .set("approvalProcess", data.approvalProcess)
                                .set("uuid", data.uuid)
                                .set("platform", data.platform)
                                .set("userId", data.userId)
                            return this.http.get<any>(this.apiUrl.apiSolrSuggList(), {
                                params: cparams,
                            });

                        } else {
                            cparams = new HttpParams()
                                .set("type", data.type)
                                .set("domainId", data.domainId)
                                .set("query", data.query)
                                .set("workstreamsIds", data.workstreamsIds)
                                .set("approvalProcess", data.approvalProcess)
                                .set("uuid", data.uuid)
                                .set("platform", data.platform)
                                .set("userId", data.userId)
                            return this.http.get<any>(this.apiUrl.apiSolrSuggList(), {
                                params: cparams,
                            });
                        }

                    } else {
                        if (platformId == '1' && data.type != 7 && data.filter == '1') {

                            if (data.shopIdInt) {
                                let paramsMap = new Map<any, any>();
                                paramsMap.set("type", data.type);
                                paramsMap.set("domainId", data.domainId);
                                paramsMap.set("query", data.query);
                                paramsMap.set("workstreamsIds", data.workstreamsIds);
                                paramsMap.set("approvalProcess", data.approvalProcess)
                                paramsMap.set("shopIdInt", data.shopIdInt)
                                paramsMap.set("uuid", data.uuid);
                                paramsMap.set("platform", data.platform);
                                paramsMap.set("userId", data.userId);
                                if (data.manufacturer && data.manufacturer != '') {
                                    paramsMap.set("manufacturer", data.manufacturer);
                                }
                                if (data.make && data.make != '') {
                                    paramsMap.set("make", data.make);
                                }
                                if (data.model && data.model.length > 0) {
                                    paramsMap.set("model", data.model);
                                }
                                if (data.year && data.year.length > 0) {
                                    paramsMap.set("year", data.year);
                                }
                                if (data.pinedUsers && data.pinedUsers.length > 0) {
                                    paramsMap.set("pinedUsers", data.pinedUsers);
                                }
                                let params = new HttpParams();
                                paramsMap.forEach((value: any, key: any) => {
                                    params = params.set(key, value);
                                });

                                return this.http.get<any>(this.apiUrl.apiSolrSuggList(), {
                                    params: params,
                                });
                            } else if (data.orFilters) {
                                let paramsMap = new Map<any, any>();
                                paramsMap.set("type", data.type);
                                paramsMap.set("domainId", data.domainId);
                                paramsMap.set("query", data.query);
                                //  paramsMap.set("workstreamsIds", data.workstreamsIds);
                                paramsMap.set("approvalProcess", data.approvalProcess)
                                paramsMap.set("orFilters", data.orFilters)
                                paramsMap.set("uuid", data.uuid);
                                paramsMap.set("platform", data.platform);
                                paramsMap.set("userId", data.userId);
                                if (data.manufacturer && data.manufacturer != '') {
                                    paramsMap.set("manufacturer", data.manufacturer);
                                }
                                if (data.make && data.make != '') {
                                    paramsMap.set("make", data.make);
                                }
                                if (data.model && data.model.length > 0) {
                                    paramsMap.set("model", data.model);
                                }
                                if (data.year && data.year.length > 0) {
                                    paramsMap.set("year", data.year);
                                }
                                if (data.pinedUsers && data.pinedUsers.length > 0) {
                                    paramsMap.set("pinedUsers", data.pinedUsers);
                                }
                                let params = new HttpParams();
                                paramsMap.forEach((value: any, key: any) => {
                                    params = params.set(key, value);
                                });

                                return this.http.get<any>(this.apiUrl.apiSolrSuggList(), {
                                    params: params,
                                });
                            } else {
                                let paramsMap = new Map<any, any>();
                                paramsMap.set("type", data.type);
                                paramsMap.set("domainId", data.domainId);
                                paramsMap.set("query", data.query);
                                paramsMap.set("workstreamsIds", data.workstreamsIds);
                                paramsMap.set("approvalProcess", data.approvalProcess)
                                paramsMap.set("uuid", data.uuid);
                                paramsMap.set("platform", data.platform);
                                paramsMap.set("userId", data.userId);
                                if (data.manufacturer && data.manufacturer != '') {
                                    paramsMap.set("manufacturer", data.manufacturer);
                                }
                                if (data.make && data.make != '') {
                                    paramsMap.set("make", data.make);
                                }
                                if (data.model && data.model.length > 0) {
                                    paramsMap.set("model", data.model);
                                }
                                if (data.year && data.year.length > 0) {
                                    paramsMap.set("year", data.year);
                                }
                                if (data.pinedUsers && data.pinedUsers.length > 0) {
                                    paramsMap.set("pinedUsers", data.pinedUsers);
                                }
                                let params = new HttpParams();
                                paramsMap.forEach((value: any, key: any) => {
                                    params = params.set(key, value);
                                });

                                return this.http.get<any>(this.apiUrl.apiSolrSuggList(), {
                                    params: params,
                                });
                            }

                        } else {
                            if (data.shopIdInt) {
                                cparams = new HttpParams()
                                    .set("type", data.type)
                                    .set("domainId", data.domainId)
                                    .set("query", data.query)
                                    .set("workstreamsIds", data.workstreamsIds)
                                    .set("shopIdInt", data.shopIdInt)
                                    .set("uuid", data.uuid)
                                    .set("platform", data.platform)
                                    .set("userId", data.userId)
                                return this.http.get<any>(this.apiUrl.apiSolrSuggList(), {
                                    params: cparams,
                                });
                            } else if (data.orFilters) {
                                cparams = new HttpParams()
                                    .set("type", data.type)
                                    .set("domainId", data.domainId)
                                    .set("query", data.query)
                                    // .set("workstreamsIds", data.workstreamsIds)
                                    .set("orFilters", data.orFilters)
                                    .set("uuid", data.uuid)
                                    .set("platform", data.platform)
                                    .set("userId", data.userId)
                                return this.http.get<any>(this.apiUrl.apiSolrSuggList(), {
                                    params: cparams,
                                });
                            } else {
                                cparams = new HttpParams()
                                    .set("type", data.type)
                                    .set("domainId", data.domainId)
                                    .set("query", data.query)
                                    .set("workstreamsIds", data.workstreamsIds)
                                    .set("uuid", data.uuid)
                                    .set("platform", data.platform)
                                    .set("userId", data.userId)
                                return this.http.get<any>(this.apiUrl.apiSolrSuggList(), {
                                    params: cparams,
                                });

                            }

                        }


                    }

                    break;
            }
        } else {
            switch (type) {
                case 'report':
                    let params = new HttpParams()
                        .set("type", data.type)
                        .set("domainId", data.domainId)
                        .set("query", data.query)
                        .set("uuid", data.uuid)
                        .set("platform", data.platform)
                        .set("userId", data.userId)
                        .set("reportWorsktream", data.reportWorsktream);
                    return this.http.get<any>(this.apiUrl.apiSolrReportSuggList(), {
                        params: params,
                    });
                    break;
                default:
                    let platformId = localStorage.getItem('platformId');
                    let cparams;
                    if (platformId == '1' && data.type != 7 && data.filter != '1') {
                        if (data.shopIdInt) {
                            cparams = new HttpParams()
                                .set("type", data.type)
                                .set("domainId", data.domainId)
                                .set("query", data.query)
                                .set("workstreamsIds", data.workstreamsIds)
                                .set("shopIdInt", data.shopIdInt)
                                .set("approvalProcess", data.approvalProcess)
                                .set("uuid", data.uuid)
                                .set("platform", data.platform)
                                .set("userId", data.userId)
                                .set("hiddenFlagInt", "0")
                            return this.http.get<any>(this.apiUrl.apiSolrSuggList(), {
                                params: cparams,
                            });
                        } else if (data.orFilters) {
                            cparams = new HttpParams()
                                .set("type", data.type)
                                .set("domainId", data.domainId)
                                .set("query", data.query)
                                //.set("workstreamsIds", data.workstreamsIds)
                                .set("orFilters", data.orFilters)
                                .set("approvalProcess", data.approvalProcess)
                                .set("uuid", data.uuid)
                                .set("platform", data.platform)
                                .set("userId", data.userId)
                                .set("hiddenFlagInt", "0")
                            return this.http.get<any>(this.apiUrl.apiSolrSuggList(), {
                                params: cparams,
                            });

                        } else if(data.type == 16) {
                            cparams = new HttpParams()
                                .set("type", data.type)
                                .set("domainId", data.domainId)
                                .set("query", data.query)
                                .set("uuid", data.uuid)
                                .set("platform", data.platform)
                                .set("userId", data.userId)
                                .set("hiddenFlagInt", "0")
                            return this.http.get<any>(this.apiUrl.apiSolrSuggList(), {
                                params: cparams,
                            });
                        } else {
                            cparams = new HttpParams()
                                .set("type", data.type)
                                .set("domainId", data.domainId)
                                .set("query", data.query)
                                .set("workstreamsIds", data.workstreamsIds)
                                .set("approvalProcess", data.approvalProcess)
                                .set("uuid", data.uuid)
                                .set("platform", data.platform)
                                .set("userId", data.userId)
                                .set("hiddenFlagInt", "0")
                            return this.http.get<any>(this.apiUrl.apiSolrSuggList(), {
                                params: cparams,
                            });
                        }

                    } else {
                        if (platformId == '1' && data.type != 7 && data.filter == '1') {

                            if (data.shopIdInt) {
                                let paramsMap = new Map<any, any>();
                                paramsMap.set("type", data.type);
                                paramsMap.set("domainId", data.domainId);
                                paramsMap.set("query", data.query);
                                paramsMap.set("workstreamsIds", data.workstreamsIds);
                                paramsMap.set("approvalProcess", data.approvalProcess)
                                paramsMap.set("shopIdInt", data.shopIdInt)
                                paramsMap.set("uuid", data.uuid);
                                paramsMap.set("platform", data.platform);
                                paramsMap.set("userId", data.userId);
                                paramsMap.set("hiddenFlagInt", "0");
                                if (data.manufacturer && data.manufacturer != '') {
                                    paramsMap.set("manufacturer", data.manufacturer);
                                }
                                if (data.make && data.make != '') {
                                    paramsMap.set("make", data.make);
                                }
                                if (data.model && data.model.length > 0) {
                                    paramsMap.set("model", data.model);
                                }
                                if (data.year && data.year.length > 0) {
                                    paramsMap.set("year", data.year);
                                }
                                if (data.pinedUsers && data.pinedUsers.length > 0) {
                                    paramsMap.set("pinedUsers", data.pinedUsers);
                                }
                                let params = new HttpParams();
                                paramsMap.forEach((value: any, key: any) => {
                                    params = params.set(key, value);
                                });

                                return this.http.get<any>(this.apiUrl.apiSolrSuggList(), {
                                    params: params,
                                });
                            } else if (data.orFilters) {
                                let paramsMap = new Map<any, any>();
                                paramsMap.set("type", data.type);
                                paramsMap.set("domainId", data.domainId);
                                paramsMap.set("query", data.query);
                                //  paramsMap.set("workstreamsIds", data.workstreamsIds);
                                paramsMap.set("approvalProcess", data.approvalProcess)
                                paramsMap.set("orFilters", data.orFilters)
                                paramsMap.set("uuid", data.uuid);
                                paramsMap.set("platform", data.platform);
                                paramsMap.set("userId", data.userId);
                                paramsMap.set("hiddenFlagInt", "0");
                                if (data.manufacturer && data.manufacturer != '') {
                                    paramsMap.set("manufacturer", data.manufacturer);
                                }
                                if (data.make && data.make != '') {
                                    paramsMap.set("make", data.make);
                                }
                                if (data.model && data.model.length > 0) {
                                    paramsMap.set("model", data.model);
                                }
                                if (data.year && data.year.length > 0) {
                                    paramsMap.set("year", data.year);
                                }
                                if (data.pinedUsers && data.pinedUsers.length > 0) {
                                    paramsMap.set("pinedUsers", data.pinedUsers);
                                }
                                let params = new HttpParams();
                                paramsMap.forEach((value: any, key: any) => {
                                    params = params.set(key, value);
                                });

                                return this.http.get<any>(this.apiUrl.apiSolrSuggList(), {
                                    params: params,
                                });
                            } else {
                                let paramsMap = new Map<any, any>();
                                paramsMap.set("type", data.type);
                                paramsMap.set("domainId", data.domainId);
                                paramsMap.set("query", data.query);
                                paramsMap.set("workstreamsIds", data.workstreamsIds);
                                paramsMap.set("approvalProcess", data.approvalProcess)
                                paramsMap.set("uuid", data.uuid);
                                paramsMap.set("platform", data.platform);
                                paramsMap.set("userId", data.userId);
                                paramsMap.set("hiddenFlagInt", "0");
                                if (data.manufacturer && data.manufacturer != '') {
                                    paramsMap.set("manufacturer", data.manufacturer);
                                }
                                if (data.make && data.make != '') {
                                    paramsMap.set("make", data.make);
                                }
                                if (data.model && data.model.length > 0) {
                                    paramsMap.set("model", data.model);
                                }
                                if (data.year && data.year.length > 0) {
                                    paramsMap.set("year", data.year);
                                }
                                if (data.pinedUsers && data.pinedUsers.length > 0) {
                                    paramsMap.set("pinedUsers", data.pinedUsers);
                                }
                                let params = new HttpParams();
                                paramsMap.forEach((value: any, key: any) => {
                                    params = params.set(key, value);
                                });

                                return this.http.get<any>(this.apiUrl.apiSolrSuggList(), {
                                    params: params,
                                });
                            }

                        } else {
                            if (data.shopIdInt) {
                                cparams = new HttpParams()
                                    .set("type", data.type)
                                    .set("domainId", data.domainId)
                                    .set("query", data.query)
                                    .set("workstreamsIds", data.workstreamsIds)
                                    .set("shopIdInt", data.shopIdInt)
                                    .set("uuid", data.uuid)
                                    .set("platform", data.platform)
                                    .set("userId", data.userId)
                                    .set("hiddenFlagInt", "0")
                                return this.http.get<any>(this.apiUrl.apiSolrSuggList(), {
                                    params: cparams,
                                });
                            } else if (data.orFilters) {
                                cparams = new HttpParams()
                                    .set("type", data.type)
                                    .set("domainId", data.domainId)
                                    .set("query", data.query)
                                    // .set("workstreamsIds", data.workstreamsIds)
                                    .set("orFilters", data.orFilters)
                                    .set("uuid", data.uuid)
                                    .set("platform", data.platform)
                                    .set("userId", data.userId)
                                    .set("hiddenFlagInt", "0")
                                return this.http.get<any>(this.apiUrl.apiSolrSuggList(), {
                                    params: cparams,
                                });
                            } else {
                                cparams = new HttpParams()
                                    .set("type", data.type)
                                    .set("domainId", data.domainId)
                                    .set("query", data.query)
                                    .set("workstreamsIds", data.workstreamsIds)
                                    .set("uuid", data.uuid)
                                    .set("platform", data.platform)
                                    .set("userId", data.userId)
                                    .set("hiddenFlagInt", "0")
                                return this.http.get<any>(this.apiUrl.apiSolrSuggList(), {
                                    params: cparams,
                                });

                            }

                        }


                    }

                    break;
            }
        }
    }

    apiclearsearchhistory(userData) {
        return this.http.post<any>(
            this.apiUrl.apiclearsearchhistory(),
            userData
        );
    }

    apiUpdateSearchKeyword(userData) {
        return this.http.post<any>(
            this.apiUrl.apiUpdateSearchKeyword(),
            userData
        );
    }

    getescalatethreadsAPI(userData) {
        return this.http.post<any>(
            this.apiUrl.apigetescalatethreadsAPI(),
            userData
        );
    }

    GetEscalationsByLevels(userData) {
        return this.http.post<any>(
            this.apiUrl.apiGetEscalationsByLevels(),
            userData
        );
    }

    
    getEscalationsThreadsView(userData) {
        return this.http.post<any>(
            this.apiUrl.apiGetEscalationsThreadsView(),
            userData
        );
    }

    

    getusersearchHistory(userData) {
        return this.http.post<any>(this.apiUrl.apigetusersearchHistory(), userData);
    }

    getAlldomainUsers(userData) {
        return this.http.post<any>(this.apiUrl.apiGetAlldomainUsers(), userData);
    }

    getServiceJobTitleList(jobData) {
        return this.http.post<any>(this.apiUrl.apiGetServiceJobTitleList(), jobData);
    }

    getServiceToolList(apiData) {
        return this.http.post<any>(this.apiUrl.apiGetServiceToolList(), apiData);
    }

    manageServiceJobTitleList(jobData) {
        return this.http.post<any>(this.apiUrl.apiManageServiceJobTitleList(), jobData);
    }

    getTechSupportCommonAPIs(userData) {
        return this.http.post<any>(this.apiUrl.apiTechSupportCommonAPIs(), userData);
    }


    readandDeleteNotification(data) {
        return this.http.post<any>(this.apiUrl.readandDeleteNotification(), data);
    }

    getThreadCharts(userData) {
        return this.http.post<any>(this.apiUrl.apiThreadCharts(), userData);
    }

    getKnowledgeArticleList(userData) {
        return this.http.post<any>(this.apiUrl.getAllKnowledgeArticle(), userData);
    }

    GetRecentViews(userData) {
        return this.http.post<any>(this.apiUrl.apiGetRecentViews(), userData);
    }

    GetEquipmentList(userData) {
        return this.http.post<any>(this.apiUrl.apiGetEquipmentList(), userData);
    }

    Getusernotifications(userData) {
        // console.log('chat userData', userData);
        return this.http.post<any>(this.apiUrl.apiusernotifications(), userData);
    }

    Resetusernotifications(userData) {
        return this.http.post<any>(
            this.apiUrl.apiresetusernotifications(),
            userData
        );
    }

    ReadandDeleteNotification(userData) {
        return this.http.post<any>(
            this.apiUrl.apiReadandDeleteNotification(),
            userData
        );
    }

    Dismissallnotifications(userData) {
        return this.http.post<any>(
            this.apiUrl.apiDismissallnotifications(),
            userData
        );
    }

    Registerdevicetoken(userData) {
        return this.http.post<any>(this.apiUrl.apiregisterdevicetoken(), userData);
    }

    getSystemActivity(userData) {
        return this.http.post<any>(this.apiUrl.apigetSystemActivity(), userData);
    }

    ActiveDevicesOnPageWeb(userData) {
        return this.http.post<any>(
            this.apiUrl.apiActiveDevicesOnPageWeb(),
            userData
        );
    }

    threadspageAPI(userData) {


        return this.http.post<any>(
            this.apiUrl.apithreadwithWorkstreams(),
            userData
        );
    }

    apiGetWebAppVersion(userData) {
        return this.http.post<any>(this.apiUrl.apiGetWebAppVersion(), userData);
    }

    EnhancedSearchAPI(userData) {
        return this.http.post<any>(this.apiUrl.apiEnhancedSearchAPI(), userData);
    }

    // add manager
    getManagerList(mData) {
        return this.http.post<any>(this.apiUrl.apiGetManagerList(), mData);
    }

    // update manager
    updateManagerList(mData) {
        return this.http.post<any>(this.apiUrl.apiUpdateManagerList(), mData);
    }

    //report widgets
    getReportsAttr(mData) {
        return this.http.post<any>(this.apiUrl.apiLandingreports(), mData);
    }

    /*
    async loadComponent(vcr: ViewContainerRef, isLoggedIn: boolean) {
      const { AnnouncementWidgetsComponent } = await import('../../components/common/announcement-widgets/announcement-widgets.component');

      //const { UserCardComponent } = await import('./user-card/user-card.component');

      vcr.clear();

      let component : any = isLoggedIn ? AnnouncementWidgetsComponent;

      return vcr.createComponent(
        this.cfr.resolveComponentFactory(component))
  }
  */

    // updatehelp content
    updateTooltipconfigWeb(mData) {
        return this.http.post<any>(this.apiUrl.apitooltipconfigWeb(), mData);
    }

    //
    updateConfigSettings(mData) {
        return this.http.post<any>(this.apiUrl.apiUpdateConfigSettings(), mData);
    }

    //
    Getworkstramsusersparticipants(mData) {
        return this.http.post<any>(this.apiUrl.apiGetworkstramsusersparticipants(), mData);
    }

    //
    getContentTypeList(mData) {
        return this.http.post<any>(this.apiUrl.apiGetContentTypeList(), mData);
    }

    techGeoLocationAPI(userData) {
        return this.http.post<any>(this.apiUrl.techGeoLocationAPI(), userData);
    }

    serviceListAPI(userData) {
        return this.http.post<any>(this.apiUrl.apiServiceList(), userData);
    }

    serviceListInfoAPI(userData) {
        return this.http.post<any>(this.apiUrl.apiServiceListInfo(), userData);
    }

    serviceListByStatusAPI(userData) {
        return this.http.post<any>(this.apiUrl.apiServiceListByStatus(), userData);
    }

    dispatchSettingsAPI(apiData) {
        return this.http.post<any>(this.apiUrl.apiDispatchSettings(), apiData);
    }

    boardSettingsAPI(apiData) {
        return this.http.post<any>(this.apiUrl.apiBoardSettings(), apiData);
    }

    apiWorkOrderTypeList(typeData) {
        return this.http.post<any>(this.apiUrl.apiWorkOrderTypeList(), typeData);
    }

    apiManageMarketData(typeData) {
        return this.http.post<any>(this.apiUrl.apiManageMarketData(), typeData);
    }

    apiGetLocationData(typeData) {
        return this.http.post<any>(this.apiUrl.apiGetLocationtData(), typeData);
    }

    apiSalesRepList(typeData) {
        return this.http.post<any>(this.apiUrl.apiSalesRepList(), typeData);
    }

    apiWorkOrderPaymentMethods(typeData) {
        return this.http.post<any>(this.apiUrl.apiWorkOrderPaymentMethods(), typeData);
    }

    apiWorkOrderPaymentTerms(typeData) {
        return this.http.post<any>(this.apiUrl.apiWorkOrderPaymentTerms(), typeData);
    }

    apiWorkOrderData(workOrderData) {
        return this.http.post<any>(this.apiUrl.apiWorkOrderData(), workOrderData);
    }

    apiWorkOrderSendEstimate(estimateData) {
        return this.http.post<any>(this.apiUrl.apiWorkOrderSendEstimate(), estimateData);
    }

    apiGetWorkOrderEstimateList(estimateData) {
        return this.http.post<any>(this.apiUrl.apiGetWorkOrderEstimateList(), estimateData);
    }

    apiManageThreadSurvey(apiData) {
        return this.http.post<any>(this.apiUrl.apiManageThreadSurvey(), apiData);
    }

    apiGetCustomerFeedbackList(apiData) {
        return this.http.post<any>(this.apiUrl.apiGetCustomerFeedbackList(), apiData);
    }

    apiGetCustomerFeedbackMetrics(apiData) {
        return this.http.post<any>(this.apiUrl.apiGetCustomerFeedbackMetrics(), apiData);
    }

    apiThreadCloseEmail(apiData) {
        return this.http.post<any>(this.apiUrl.apiThreadCloseEmail(), apiData);
    }

    apiAccecptEstimate(estimateData) {
        return this.http.post<any>(this.apiUrl.apiAccecptEstimate(), estimateData);
    }

    apiWorkOrderSendInvoice(invoiceData) {
        return this.http.post<any>(this.apiUrl.apiWorkOrderSendInvoice(), invoiceData);
    }

    apiWorkOrderUpdate(data) {
        return this.http.post<any>(this.apiUrl.apiWorkOrderUpdate(), data);
    }

    serviceJobTypeListApi(invoiceData) {
        return this.http.post<any>(this.apiUrl.apiServiceJobTypeList(), invoiceData);
    }

    shopMsoListAPI(userData) {
        let ctid = ContentTypeValues.RepairOrder;
        let shopId = (userData.shopId) ? userData.shopId : 0;
        let offset = (userData.offset) ? userData.offset : 0;
        let limit = (userData.limit) ? userData.limit : 0;
        let version = (userData.version) ? userData.version : 0;
        let keyword = (userData.keyword) ? userData.keyword : '';
        const params = new HttpParams()
            .set("apikey", userData.apikey)
            .set("countryId", userData.countryId)
            .set("domainId", userData.domainId)
            .set("userId", userData.userId)
            .set("shopId", shopId)
            .set('shopArr', userData.shopArr)
            .set('keyword', keyword)
            .set("offset", offset)
            .set("limit", limit)
            .set("version", version)
            .set("contentTypeId", ctid)
            .set("msoNameId", userData?.msoNameId);
        return this.http.get<any>(this.apiUrl.apiShopList(), {
            params: params,
        });
    }

    shopListAPI(userData) {
        let ctid = (userData.contentTypeId) ? userData.contentTypeId : ContentTypeValues.Dispatch;
        let shopId = (userData.shopId) ? userData.shopId : 0;
        let offset = (userData.offset) ? userData.offset : 0;
        let limit = (userData.limit) ? userData.limit : 0;
        let version = (userData.version) ? userData.version : 0;
        let keyword = (userData.keyword) ? userData.keyword : '';
        const params = new HttpParams()
            .set("apikey", userData.apikey)
            .set("countryId", userData.countryId)
            .set("domainId", userData.domainId)
            .set("userId", userData.userId)
            .set("shopId", shopId)
            .set("shopId", shopId)
            .set('shopArr', userData.shopArr)
            .set('keyword', keyword)
            .set("offset", offset)
            .set("limit", limit)
            .set("version", version)
            .set("contentTypeId", ctid);
        return this.http.get<any>(this.apiUrl.apiShopList(), {
            params: params,
        });
    }

    statusListAPI(userData) {
        const params = new HttpParams()
            .set("apikey", userData.apikey)
            .set("countryId", userData.countryId)
            .set("domainId", userData.domainId)
            .set("userId", userData.userId);
        return this.http.get<any>(this.apiUrl.apiStatusList(), {
            params: params,
        });
    }

    serviceContactListAPI(userData) {
        const params = new HttpParams()
            .set("apikey", userData.apikey)
            .set("domainId", userData.domainId)
            .set("userId", userData.userId)
            .set("shopId", userData.shopId)
            .set("contactList", userData.contactList);
        return this.http.get<any>(this.apiUrl.apiServiceContactList(), {
            params: params,
        });
    }

    /* technicianAPI(userData) {
      return this.http.post<any>(this.apiUrl.apoTechnicianList(), userData);
    } */

    manageServiceAPI(userData) {
        return this.http.post<any>(this.apiUrl.apiManageService(), userData);
    }

    updateDispatchFieldSolrAPI(data) {
        return this.http.post<any>(this.apiUrl.apiUpdateDispatchFieldSolr(), data);
    }

    manageServiceCatgAPI(catgData) {
        return this.http.post<any>(this.apiUrl.apiManageServiceCatg(), catgData);
    }

    manageServiceContactAPI(contactData) {
        return this.http.post<any>(this.apiUrl.apiManageServiceContact(), contactData);
    }

    manageServiceShopAPI(shopData) {
        return this.http.post<any>(this.apiUrl.apiManageServiceShop(), shopData);
    }

    manageAttributeAPI(attributeData) {
        return this.http.post<any>(this.apiUrl.apiManageAttributeAPI(), attributeData);
    }

    manageCustomerDiscountAPI(attributeData) {
        return this.http.post<any>(this.apiUrl.apiManageCustomerDiscountAPI(), attributeData);
    }

    checkDuplicate(data) {
        return this.http.post<any>(this.apiUrl.apiCheckDuplicate(), data);
    }

    serviceCategory(userData) {
        const params = new HttpParams()
            .set("apikey", userData.apikey)
            .set("domainId", userData.domainId)
            .set("userId", userData.userId);
        return this.http.get<any>(this.apiUrl.apiServiceCategory(), {
            params: params,
        });
    }

    vehicleInfoByVIN(userData) {
        return this.http.post<any>(this.apiUrl.apiVehiclebyVIN(), userData);
    }

    getProductMakeListsAPI(userData) {
        return this.http.post<any>(this.apiUrl.apiGetProductmakeList(), userData);
    }

    getMakeModelsList(userData) {
        let workstreamsList = (userData?.workstreamsList && userData.workstreamsList != undefined) ? userData.workstreamsList : [];
        const params = new HttpParams()
            .set("apiKey", userData.apiKey)
            .set("domainId", String(userData.domainId))
            .set("countryId", userData.countryId)
            .set("userId", userData.userId)
            .set("displayOrder", userData.displayOrder)
            .set("type", userData.type)
            .set("makeName", userData.makeName)
            .set("offset", userData.offset)
            .set("limit", userData.limit)
            .set("workstreamsList", JSON.stringify(workstreamsList));
        return this.http.post<any>(this.apiUrl.apiModels(), "", {
            params: params,
        });
    }

    // Standard Report API's
    getStandardReportlistsAPI(reportData) {
        return this.http.post<any>(this.apiUrl.apiStandardReportLists(), reportData);
    }

    // Manage Report
    manageReportAPI(reportData) {
        return this.http.post<any>(this.apiUrl.apiManageReport(), reportData);
    }

    // Manage Manufacturer Alternate Name
    manageAltMfgNameAPI(reportData) {
        return this.http.post<any>(this.apiUrl.apiManageAltMfgNameAPI(), reportData);
    }

    // Get Mfg List
    getMfgList(apiData) {
        return this.http.post<any>(this.apiUrl.apiGetMfgList(), apiData);
    }

    // Get Workstream Lists
    getWorkstreamLists(userData) {
        return this.http.post<any>(this.apiUrl.apiGetWorkstreamLists(), userData);
    }

    // Get Subscription Workstream Lists
    getSubscriptionWorkstreamLists(userData) {
        return this.http.post<any>(this.apiUrl.apiGetSubscriptionWorkstreamLists(), userData);
    }

    // CBT V3 Push
    cbtV3SendPush(pushData) {
        return this.http.post<any>(this.apiUrl.apiV3SendPush(), pushData);
    }

    cbtV3SendROPush(pushData) {
        return this.http.post<any>(this.apiUrl.apiV3SendROPush(), pushData);
    }

    cbtV3SendCalproPush(pushData) {
        return this.http.post<any>(this.apiUrl.apiV3SendCalproPush(), pushData);
    }

    updateThreadTechSupportAPI(userData) {
        return this.http.post<any>(this.apiUrl.apiUpdateThreadTechSupport(), userData);
    }

    saveTechSupportTeams(userData) {
        return this.http.post<any>(this.apiUrl.apiSaveTechSupportTeams(), userData);
    }

    updateDefaultTeam(userData) {
        return this.http.post<any>(this.apiUrl.apiUpdateDefaultTeam(), userData);
    }

    checkSupportTeamName(userData) {
        return this.http.post<any>(this.apiUrl.apiCheckSupportTeamName(), userData);
    }

    apiTechSupportMenusAPI(userData) {
        return this.http.post<any>(this.apiUrl.apiTechSupportMenus(), userData);
    }


    techSupportWidgetsAPI(userData) {
        return this.http.post<any>(this.apiUrl.apiTechSupportWidgets(), userData);
    }

    techSupportPriorityDataList(userData) {
        return this.http.post<any>(this.apiUrl.apiTechSupportPriorityDataList(), userData);
    }

    updateTechSupportPriorityData(userData) {
        return this.http.post<any>(this.apiUrl.apiupdateTechSupportPriorityData(), userData);
    }


    getSolrSearchReport(reportData) {
        const body = JSON.stringify(reportData);
        return this.http.post<any>(this.apiUrl.apiSolrReportSearchList(), body)
    }

    manageSolrReport(reportData) {
        const body = JSON.stringify(reportData);
        return this.http.post<any>(this.apiUrl.apiSolrManageReport(), body)
    }

    manageSolrBulkIndex(bulkData) {
        const body = JSON.stringify(bulkData);
        return this.http.post<any>(this.apiUrl.apiSolrBulkIndex(), body)
    }

    customerResetPassword(data) {
        return this.http.post<any>(this.apiUrl.apiCustomerResetPassword(), data);
    }

    // updatehelp content
    docApprovalStatusChangeAPI(mData) {
        return this.http.post<any>(this.apiUrl.apiDocApprovalStatusChange(), mData);
    }

    // updatehelp content
    sharedFixApprovalStatusChangeAPI(mData) {
        return this.http.post<any>(this.apiUrl.apiSharedFixApprovalStatusChange(), mData);
    }

    // updatehelp content
    kaizenApprovalStatusChangeAPI(mData) {
        return this.http.post<any>(this.apiUrl.apiKaizenApprovalStatusChange(), mData);
    }


    getOpportunityList(optData) {
        return this.http.post<any>(this.apiUrl.apiOpportunityList(), optData);
    }

    // Update Mfg Name Api
    updateMfgName(data) {
        const params = new HttpParams()
            .set("apiKey", data.apiKey)
            .set("domainId", data.domainId)
        return this.http.get<any>(this.apiUrl.apiUpdateMfgName(), {
            params: params,
        });
    }

    // Get Recall Data
    getRecallData(recallData) {
        return this.http.post<any>(this.apiUrl.apiRecallData(), recallData);
    }

    manageUserPageActivityAPI(activityData) {
        return this.http.post<any>(this.apiUrl.apiManageUserPageActivityAPI(), activityData);
    }

    // Check RO Contact Exists
    checkROContactExists(apiData) {
        return this.http.post<any>(this.apiUrl.apiCheckROContactExists(), apiData);
    }

    // recent list
    adasrecentlist(apiData) {
        return this.http.post<any>(this.apiUrl.apiAdasrecentlist(), apiData);
    }

    // apiFindAdasVehicleLocations
    findAdasVehicleLocations(apiData) {
        return this.http.post<any>(this.apiUrl.apiFindAdasVehicleLocations(), apiData);
    }

    findMediaByLocations(apiData) {
        return this.http.post<any>(this.apiUrl.apiFindMediaByLocations(), apiData);
    }

    vehicleSurveyList(apiData) {
        return this.http.post<any>(this.apiUrl.apiVehicleSurveyList(), apiData);
    }

    updateInspectionSurvey(apiData) {
        return this.http.post<any>(this.apiUrl.apiUpdateInspectionSurvey(), apiData);
    }

    manageAdditionalSystem(apiData) {
        return this.http.post<any>(this.apiUrl.apiManageAdditionalSystem(), apiData);
    }

    vinAutoDataDecode(apiData) {
        return this.http.post<any>(this.apiUrl.apiVinAutoDataDecode(), apiData);
    }

    getTsbData(apiData) {
        return this.http.post<any>(this.apiUrl.apiGetTsbData(), apiData);
    }

    getOpenRecallsData(apiData) {
        return this.http.post<any>(this.apiUrl.apiGetOpenRecalls(), apiData);
    }

    getRecentVinHistoryData(apiData) {
        return this.http.post<any>(this.apiUrl.apiGetRecentVinHistory(), apiData);
    }

    getSearchHistoryRecommend(apiData) {
        return this.http.post<any>(this.apiUrl.apiSearchHistoryRecommend(), apiData);
    }

    // Share Adas Report
    adasShareReport(apiData) {
        return this.http.post<any>(this.apiUrl.apiAdasShareReport(), apiData);
    }


    // list
    diagnosticlist(apiData) {
        return this.http.post<any>(this.apiUrl.apiDiagnosticlist(), apiData);
    }

    
    // list
   getrounprocessedlist(apiData) {
        return this.http.post<any>(this.apiUrl.apiGetrounprocessedlist(), apiData);
    }

    getInstallerplannedlist(apiData) {
        return this.http.post<any>(this.apiUrl.apiInstallerplannedlist(), apiData);
    }

    getExcelforgbbreportdatalist(apiData) {
        return this.http.post<any>(this.apiUrl.apiExcelforgbbreportdatalist(), apiData);
    }

    getlogoptionslist(apiData) {
        return this.http.post<any>(this.apiUrl.apiGetlogoptionslist(), apiData);
    }

    
    getManageContentImportHistoryList(apiData) {
        return this.http.post<any>(this.apiUrl.apiGetManageContentImportHistory(), apiData);
    } 

   getManageContentDirImportHistory(apiData) {
        return this.http.post<any>(this.apiUrl.apiGetManageContentDirImportHistory(), apiData);
    } 
    
    deleteManageContentImportHistory(apiData) {
        return this.http.post<any>(this.apiUrl.apiDeleteManageContentImportHistory(), apiData);
    } 

    getManageContentModellist(apiData) {
        return this.http.post<any>(this.apiUrl.apiGetManageContentModellist(), apiData);
    }

    getsplashscreenlist(apiData) {
        return this.http.post<any>(this.apiUrl.apiGetsplashscreenlist(), apiData);
    }    
    
    Uploaddealernpsfile(apiData) {
        return this.http.post<any>(this.apiUrl.apiUploaddealernpsfile(), apiData);
    }

    Uploaddealerdirfile(apiData) {
        return this.http.post<any>(this.apiUrl.apiUploaddealerdirfile(), apiData);
    }
    
     getNewImportHistory(apiData) {
        return this.http.post<any>(this.apiUrl.apiNewImportHistory(), apiData);
    }

     getNewImportDirHistory(apiData) {
        return this.http.post<any>(this.apiUrl.apiNewImportDirHistory(), apiData);
    }
    
            
    // list
    diagnosticUpdate(apiData) {
        return this.http.post<any>(this.apiUrl.apiDiagnosticUpdate(), apiData);
    }

    // list
    diagnosticDelete(apiData) {
        return this.http.post<any>(this.apiUrl.apiDiagnosticDelete(), apiData);
    }

    manageSolrImagesExtract(reportData) {
        return this.http.post<any>(this.apiUrl.apiSolrImagesExtract(), reportData, {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }

  createDoc(payLoad) {
    return this.http.post(this.apiUrl.apiCreateDocument(), payLoad)
  }

  getUploadS3PresignedUrl(payLoad) {
    return this.http.post(this.apiUrl.uploadS3(), payLoad)
  }

  uploadToS3ResponseUrl(url, file) {
    return this.http.put(url, file, {
        reportProgress: true,
        observe: 'events'
    })
  }

  attachDoc(payLoad) {
    return this.http.post(this.apiUrl.attachDocUpload(), payLoad, {
          reportProgress: true,
          headers: new HttpHeaders({ "Accept": "application/json" }),
          observe: 'events'
        }).pipe(
          catchError(this.errorMgmt)
        )
  }

  updateSolrShopStatus(payLoad) {
    return this.http.post(this.apiUrl.apiUpdateSolrShopStatus(), payLoad)
  }

  getMediaUploadStatus(payLoad) {
    return this.http.post(this.apiUrl.apigetUploadMediaStatus(), payLoad)
  }

getMediaUploadStatusNew(payLoad) {
    return this.http.post(this.apiUrl.apigetUploadMediaStatusNew(), payLoad)
  }

  getInventoryMetrics(payLoad) {
    return this.http.post(this.apiUrl.apiGetInventoryMetrics(), payLoad)
  }

  getInventoryMetricsV2(payLoad) {
    return this.http.post(this.apiUrl.apiGetInventoryMetricsv2(), payLoad)
  }

  getInventoryQtyDetails(payLoad) {
    return this.http.post(this.apiUrl.apiGetInventoryQtyDetails(), payLoad)
  }

  getInventoryWarehouseInfo(payLoad) {
    return this.http.post(this.apiUrl.apiGetInventoryWarehouseInfo(), payLoad)
  }

  getInventoryWarehouseDetails(payLoad) {
    return this.http.post(this.apiUrl.apiGetInventoryWarehouseDetails(), payLoad)
  }

  getInstallerTruckList(payLoad) {
    return this.http.post(this.apiUrl.apiGetInstallerTruckList(), payLoad)
  }

  getInventoryWarehouseList(payLoad) {
    return this.http.post(this.apiUrl.apiGetInventoryWarehouseList(), payLoad)
  }

  moveserialnumber(payLoad) {
    return this.http.post(this.apiUrl.apiMoveserialnumber(), payLoad)
  }  

  moveserialnumberCore(payLoad) {
    return this.http.post(this.apiUrl.apiMoveserialnumberCore(), payLoad)
  }  

  getInventoryPartsByWarehouse(payLoad) {
    return this.http.post(this.apiUrl.apiGetInventoryPartsByWarehouse(), payLoad)
  }

  getInventoryTruckList(payLoad) {
    return this.http.post(this.apiUrl.apiGetInventoryTruckList(), payLoad)
  }

  saveserialNoInfo(payLoad) {
    return this.http.post(this.apiUrl.apiSaveserialNoInfo(), payLoad)
  }

  deleteSerialNoInfo(payLoad) {
    return this.http.post(this.apiUrl.apiDeleteserialNoInfo(), payLoad)
  }

  importSerialNumber(payLoad) {
    return this.http.post(this.apiUrl.apiImportSerialNumber(), payLoad)
  }

  exportInventory(payLoad) {
    return this.http.post(this.apiUrl.apiExportInventory(), payLoad)
  }

  downloadTemplate(payLoad) {
    return this.http.post(this.apiUrl.apiDownloadTemplate(), payLoad)
  }
  
  getInventoryMasterList(payLoad) {
    return this.http.post(this.apiUrl.apiGetInventoryMasterList(), payLoad)
  }
  
  getsnofrompartno(payLoad) {
    return this.http.post(this.apiUrl.apiGetsnofrompartno(), payLoad)
  }
  
  getSerialImportHistory(payLoad) {
    return this.http.post(this.apiUrl.apiGetSerialImportHistory(), payLoad)
  }
  
  // Map Work Order Calpre
  mapWorkOrderCalpro(data) {
    return this.http.post<any>(this.apiUrl.apiRoAdasMap(), data);
  }

   serviceUpdateAPI(data) {
        return this.http.post<any>(this.apiUrl.apiServiceUpdate(), data);
    }

  // QBO Connection Verification
  apiQBOCheck(data) {
    return this.http.post<any>(this.apiUrl.apiQBOCheck(), data);
  }

  // Get QBO Client ID
  getQBOClientId(data) {
    return this.http.post<any>(this.apiUrl.apiQBOClientId(), data);
  }

  // Setup QBO Token
  setupQBOToken(data) {
    return this.http.post<any>(this.apiUrl.apiSetupQBOToken(), data);    
  }

  // Disconnect QBO
  disconnectQBO(data) {
    return this.http.post<any>(this.apiUrl.apiDisconnectQBO(), data);    
  }

  getTechniciansWithStatus(data) {
    return this.http.post<any>(this.apiUrl.apiTechniciansWithStatus(), data);    
  }

  apiManageTechnicianStatus(data) {
    return this.http.post<any>(this.apiUrl.apiManageTechnicianStatus(), data);    
  }

  apiGetUserShortcuts(data) {
    return this.http.post<any>(this.apiUrl.apiGetUserShortcuts(), data);    
  }

  apiSetUserShortcut(data) {
    return this.http.post<any>(this.apiUrl.apiSetUserShortcut(), data);    
  }

  apiAssignTech(data) {
    return this.http.post<any>(this.apiUrl.apiAssignTech(), data);
  }

  apiGetTimeZoneByDate(data) {
    return this.http.post<any>(this.apiUrl.apiGetTimeZoneByDate(), data);
  }

  apiGetROTimeLineInfo(data) {
    return this.http.post<any>(this.apiUrl.apiGetROTimeLineInfo(), data);
  }

  apiGetROActivityLogInfo(data) {
    return this.http.post<any>(this.apiUrl.apiGetROActivityLogInfo(), data);
  }

}